import axios from "axios";
import { baseURL } from "../utilits/config";




export function getAllUsers(callback) {
  const config = {
    method: "get",
    url: baseURL + "/whatsapp",
    headers: {},
  };
  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function getActiveUser(callback){
      const config = {
        method: "get",
        url: baseURL + "/get-active-users",
        headers: {},
      };
      axios(config)
        .then((result) => {
          callback(result.data);
        })
        .catch((error) => {
          callback(error);
        });
    
}
